module.exports = __webpack_public_path__ + "img/Pellets-wirkungsgrad.d073623.webp";